import React, { Fragment } from 'react'

const FIRST_PAGE = 'FIRST'
const LEFT_PAGE = 'LEFT'
const RIGHT_PAGE = 'RIGHT'
const LAST_PAGE = 'LAST'

class Pagination extends React.Component {
  constructor(props) {
    super(props)
    this.state = { currentPage: 1 }
  }

  range = (frm, to, step = 1) => {
    let i = frm
    const range = []

    while (i <= to) {
      range.push(i)
      i += step
    }
    return range
  }

  fetchPageNumbers = () => {
    const numPages = this.props.numPages
    const currentPage = this.props.currentPage
    const pageNeighbors = this.props.pageNeighbors

    /**
     * totalNumbers: the total page numbers to show on the control
     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
     */
    const totalNumbers = pageNeighbors * 2 + 3
    const totalBlocks = totalNumbers + 2

    if (numPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbors)
      const endPage = Math.min(numPages - 1, currentPage + pageNeighbors)

      let pages = this.range(startPage, endPage)

      /**
       * hasLeftSpill: has hidden pages to the left
       * hasRightSpill: has hidden pages to the right
       * spillOffset: number of hidden pages either to the left or to the right
       */
      const hasLeftSpill = startPage > 2
      const hasRightSpill = numPages - endPage > 1
      const spillOffset = totalNumbers - (pages.length + 1)

      switch (true) {
        case hasLeftSpill && !hasRightSpill: {
          const extraPages = this.range(startPage - spillOffset, startPage - 1)
          pages = [...extraPages, ...pages, numPages]

          break
        }

        case !hasLeftSpill && hasRightSpill: {
          const extraPages = this.range(endPage + 1, endPage + spillOffset)
          pages = [1, ...pages, ...extraPages]
          break
        }

        case hasLeftSpill && hasRightSpill:
        default: {
          pages = [...pages]
          break
        }
      }
      return pages
    }
    return this.range(1, numPages)
  }

  render() {
    if (this.numPages === 1) return null

    const pages = this.fetchPageNumbers()
    return (
      <Fragment>
        <nav aria-label="pagination">
          <ul className="pagination">
            {pages.map((page, index) => {
              return (
                <li
                  key={index}
                  className={`page-item${
                    this.props.currentPage === page ? ' active' : ''
                  }`}
                >
                  <a
                    className="page-link"
                    href={
                      `/${this.props.type === 'post' ? 'blog' : 'video'}/` +
                      (page === 1 ? '' : 'page' + page)
                    }
                  >
                    {page}
                  </a>
                </li>
              )
            })}
          </ul>
        </nav>
      </Fragment>
    )
  }
}

export default Pagination
